import _Transfer from './Transfer';

import './style/index.js';

export type { TransferProps } from './Transfer';
export * from './type';

export const Transfer = _Transfer;
export default Transfer;
